import { getDistance } from 'ol/sphere';
// import { point, distance } from "@turf/turf";
/**
 * 計算距離
 * @param {Array} from 起
 * @param {Array} to 迄
 * @returns {(Number)} from and to distance
 */
// eslint-disable-next-line import/prefer-default-export
export const getDistanceByPoint = (from, to) => getDistance(from, to);

// export const getDistanceByPoint = (from, to) => {
//   const point1 = point(from);
//   const point2 = point(to);
//   return distance(point1, point2, { units: "kilometers" }) * 1000;
// };
